import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden" data-id="element-104">
      <div className="absolute inset-0 bg-brand-orange/10 blur-[150px] rounded-full max-w-3xl mx-auto" data-id="element-105" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-107">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-brand-cream mb-8 leading-tight" data-id="element-108">
            💪 SÌ, VOGLIO{' '}
            <span className="text-brand-orange" data-id="element-109">RIVOLUZIONARE</span> IL MIO MODO
            DI INSEGNARE
          </h2>

          <CTAButton className="text-lg sm:text-xl py-5 px-8 w-full sm:w-auto max-w-xl mx-auto mb-6" data-id="element-110">
            ACCEDI ORA AL SISTEMA
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-4 text-brand-gold font-bold text-sm sm:text-base" data-id="element-111">
            <span data-id="element-112">⚡ Accesso Immediato</span>
            <span data-id="element-113">•</span>
            <span data-id="element-114">🛡️ Garanzia 7 Giorni</span>
          </div>
        </motion.div>
      </div>
    </section>;
}